import instance from "./instance";
export const findAll = () => {
    return instance.get(`/colorCharts`)
        .then(response => ({ response }))
        .catch(error => ({ error }));
};
